import React from 'react';
import { useT } from '../context/LanguageContext';

/**
 * Centralized page header so alle 15 paginas via 1 component-call vertaalbaar zijn.
 * Usage: <PageHeader pageKey="customers"> ... extra buttons ... </PageHeader>
 *
 * Translation keys gebruikt:
 *   page.<pageKey>.title  - bv. "Klanten"
 *   page.<pageKey>.sub    - subtitel onder de titel
 */
export default function PageHeader({ pageKey, title, subtitle, children, testid }) {
  const { t } = useT();
  const resolvedTitle = title || t(`page.${pageKey}.title`);
  const resolvedSub = subtitle != null ? subtitle : t(`page.${pageKey}.sub`);
  return (
    <div className="cs-page-header" data-testid={testid || `page-header-${pageKey}`}>
      <div>
        <h2>{resolvedTitle}</h2>
        {resolvedSub && <p>{resolvedSub}</p>}
      </div>
      {children}
    </div>
  );
}
